export const USD = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0
});

export const PERCENT = new Intl.NumberFormat('en-US', {
  style: 'percent',
  maximumFractionDigits: 1
});

export function formatCurrency(value: number): string {
  return USD.format(value);
}

export function formatPercent(value: number): string {
  return PERCENT.format(value);
}
